import React, { useRef } from "react";
import * as PropTypes from "prop-types";
import { reportingYear } from "../../../constants";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import MethodMixChart from "../charts/MethodMixChart";
import { formatValue } from "../../../utilities";

const ShareOfConsumptionCostsByMethodChartWidget = props => {
  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="share_of_consumption_costs_by_method_chart"
      reference="Figure 4.6"
      title={`Share of Consumption Costs by Method, ${reportingYear}`}
      subtitle="Comparison by GNI Group"
      contentWidth={350}
      initialAbsolute={false}
      chartRef={ref}
    >
      <MethodMixChart
        ref={ref}
        data={props.data}
        tooltipFormatter={function() {
          return `${this.series.name} Costs in ${
            this.key
          } <strong>${formatValue(Math.abs(this.y))}</strong><br />Share of ${
            this.key
          } Costs: <strong>${formatValue(
            Math.abs(this.percentage) / 100,
            true
          )}</strong>`;
        }}
      />
    </AbsoluteChartToggleFrame>
  );
};

ShareOfConsumptionCostsByMethodChartWidget.propTypes = {
  data: PropTypes.array.isRequired
};

export default ShareOfConsumptionCostsByMethodChartWidget;
